import { GraphQLError } from 'graphql'
import { logException } from '@babylon/sentry'
import isPossiblyJson from './isPossiblyJson'

const removeQueryBody = (message: string) =>
  message?.replace(/{[^}]+}/, '[Filtered]')

const parseError = (error: GraphQLError) => {
  const errorMessage = error?.message
  const isJson = isPossiblyJson(errorMessage)

  if (!isJson) {
    // If the message is not starting with { or [, it's not a valid JSON anyway.
    // Let's just return it as is.
    return removeQueryBody(errorMessage)
  }

  try {
    return JSON.parse(errorMessage)
  } catch (e) {
    if (error) {
      logException({
        ...error,
        // Filter out query body from the error
        message: removeQueryBody(errorMessage),
      })
    } else {
      logException(e)
    }

    // Trigger a flash message for an unknown error
    return { unparsedError: true }
  }
}

export default parseError
